<template>
	<div class="pa-2">
		<v-row
			align="center"
			dense
			class="mb-2">
			<v-spacer></v-spacer>
			<v-col cols="auto">
				<v-btn
					@click="addAllowanceDialog = true"
					small
					color="primary">
					<v-icon left> $add </v-icon>
					{{ $T('add') }}
				</v-btn>
			</v-col>
		</v-row>

		<bee-handy-table
			:headers="allowanceHeader"
			:items="loading ? [] : allowanceItems"
			:data-table-props="{ disableSort: true }"
			:loading="loading"
			elevation="3"
			dense
			zebra
			fixed-header
			:items-per-page="-1"
			:height="$vuetify.breakpoint.height - 180"
			hide-default-footer>
			<template v-slot:item.penalty="{ item }">
				<tooltip
					v-if="item.penalty"
					:text="$T('tooltips.hasEffect')">
					<v-icon
						size="20"
						color="black">
						mdi-check-circle-outline
					</v-icon>
				</tooltip>
				<tooltip
					v-else
					:text="$T('tooltips.hasntEffect')">
					<v-icon
						size="20"
						color="black">
						mdi-close-circle-outline
					</v-icon>
				</tooltip>
			</template>
			<template v-slot:item.attendance="{ item }">
				<tooltip
					v-if="item.attendance"
					:text="$T('tooltips.hasEffect')">
					<v-icon
						size="20"
						color="black">
						mdi-check-circle-outline
					</v-icon>
				</tooltip>
				<tooltip
					v-else
					:text="$T('tooltips.hasntEffect')">
					<v-icon
						size="20"
						color="black">
						mdi-close-circle-outline
					</v-icon>
				</tooltip>
			</template>
			<template v-slot:item.actions="{}">
				<tooltip :text="$T('tooltips.preview')">
					<v-btn
						small
						icon>
						<v-icon
							size="20"
							color="preview">
							$view
						</v-icon>
					</v-btn>
				</tooltip>
			</template>
		</bee-handy-table>

		<v-dialog
			v-model="addAllowanceDialog"
			:max-width="400"
			transition="dialog-transition">
			<v-card elevation="3">
				<form @submit.prevent>
					<v-card-title primary-title>
						إضافة بدل
						<v-spacer></v-spacer>
						<v-btn
							@click="addAllowanceDialog = false"
							icon>
							<v-icon color="alert-color">mdi-close</v-icon>
						</v-btn>
					</v-card-title>
					<v-card-text>
						<v-row dense>
							<v-col cols="12">
								<v-text-field
									v-model="addAllowance.name"
									outlined
									dense
									:label="$T('addAllowance.name')"
									hide-details></v-text-field>
							</v-col>
							<v-col cols="6">
								<v-text-field
									v-model="addAllowance.price"
									outlined
									dense
									:label="$T('addAllowance.price')"
									hide-details></v-text-field>
							</v-col>
							<v-col cols="6">
								<v-select
									v-model="addAllowance.frequency"
									:items="frequencyItems"
									outlined
									dense
									:label="$T('addAllowance.frequency')"
									hide-details></v-select>
							</v-col>
							<v-col cols="12">
								<v-checkbox
									v-model="addAllowance.attendance"
									class="mt-0"
									outlined
									dense
									:label="$T('addAllowance.attendance')"
									hide-details></v-checkbox>
							</v-col>
							<v-col cols="12">
								<v-checkbox
									v-model="addAllowance.penalty"
									class="mt-0"
									outlined
									dense
									:label="$T('addAllowance.penalty')"
									hide-details></v-checkbox>
							</v-col>
						</v-row>
					</v-card-text>
					<v-card-actions class="align-center">
						<v-spacer></v-spacer>
						<v-btn
							color="secondary"
							@click="addAllowanceDialog = false">
							{{ $T('default-buttons.save') }}
						</v-btn>
					</v-card-actions>
				</form>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
export default {
	name: 'AddAllowanceType',

	data() {
		return {
			addAllowanceDialog: false,

			addAllowance: {},

			allowanceHeader: [
				{ text: this.$T('headers.name'), name: 'name', value: 'name' },
				{ text: this.$T('headers.value'), name: 'value', value: 'value' },
				{ text: this.$T('headers.frequency'), name: 'frequency', value: 'frequency' },
				{ text: this.$T('headers.attendance'), name: 'attendance', value: 'attendance', width: 60 },
				{ text: this.$T('headers.penalty'), name: 'penalty', value: 'penalty', width: 60 },
				{ text: '', name: 'actions', value: 'actions', width: 40 },
			],

			allowanceItems: [{ attendance: false }, { attendance: true }],

			frequencyItems: ['مرة بالعمر', 'كل سنة', 'كل شهر', 'كل أسبوع', 'كل يوم'],
		};
	},
};
</script>

<style lang="scss" scoped></style>
